module.exports = __webpack_public_path__ + "static/img/mobile_work_order_create.2e4ac778.png";